import React from 'react';

import PageLayout from '../../../components/PageLayout';

import CookieCruncher from './CookieCruncher';

async function action() {
  return {
    title: 'Cookie Cruncher',
    description:
      'Flux Tech | Fatal Studios | Cookie Cruncher is the ultimate cookie-destruction mobile game available now for iPhone and Android',
    chunks: ['cookie-cruncher'],
    component: (
      <PageLayout>
        <CookieCruncher />
      </PageLayout>
    ),
  };
}

export default action;
